import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SatisfactionSurveyDuplicateComponent } from './satisfaction-survey-duplicate/satisfaction-survey-duplicate.component';
import { SharedModule } from '../../shared.module';

/**
 * Handle the features used in the both mode CARE and MARKETING.
 */
@NgModule({
  declarations: [SatisfactionSurveyDuplicateComponent],
  imports: [CommonModule, SharedModule],
})
export class SatisfactionSurveysModule {}
